module.exports = __webpack_public_path__ + "img/BT.f33537a9.png";